import { useEffect, useRef, useState } from 'react';
import { D, formatMoney } from '@makila/fiscal';
import { Gift, X } from 'lucide-react';
import clsx from 'clsx';

const PRESETS = ['500', '1000', '2000', '5000'];
const VALIDITY = [{ v: 180, l: '6 meses' }, { v: 365, l: '1 ano' }, { v: 0, l: 'Sem prazo' }];

/** Vender um vale-oferta: valor, validade e (opcional) quem o compra. Segue-se o pagamento. */
export function VoucherDialog(p: { onClose: () => void; onNext: (v: { amount: string; validityDays: number | null; buyer: string }) => void }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => { ref.current?.showModal(); }, []);
  const [amount, setAmount] = useState('1000');
  const [validity, setValidity] = useState(365);
  const [buyer, setBuyer] = useState('');
  const n = /^\d{1,7}([.,]\d{1,2})?$/.test(amount.trim()) ? new D(amount.trim().replace(',', '.')) : null;
  return (
    <dialog ref={ref} onCancel={(e) => { e.preventDefault(); p.onClose(); }} className="m-auto w-[min(560px,96vw)] rounded-2xl bg-[var(--surface)] p-0 text-[var(--text)]">
      <div className="flex items-center justify-between border-b border-base px-5 py-3">
        <h2 className="flex items-center gap-2 text-xl font-bold"><Gift size={22} className="text-brand-700" /> Vale-oferta</h2>
        <button aria-label="Fechar" onClick={p.onClose} className="grid h-12 w-12 place-items-center rounded-lg"><X /></button>
      </div>
      <form className="space-y-5 p-5" onSubmit={(e) => { e.preventDefault(); if (n?.greaterThan(0)) p.onNext({ amount: n.toFixed(2), validityDays: validity || null, buyer: buyer.trim() }); }}>
        <div>
          <div className="mb-2 text-sm font-semibold">Valor</div>
          <div className="grid grid-cols-4 gap-2">
            {PRESETS.map((v) => <button key={v} type="button" aria-pressed={amount === v} onClick={() => setAmount(v)} className={clsx('num h-12 rounded-xl border-2 font-semibold', amount === v ? 'border-brand-700 bg-brand-700 text-white' : 'border-base')}>{formatMoney(v, 0)}</button>)}
          </div>
          <div className="mt-2 flex items-center gap-2">
            <input inputMode="decimal" aria-label="Outro valor" value={amount} onChange={(e) => setAmount(e.target.value)} className="num h-14 min-w-0 flex-1 rounded-xl border border-base bg-surface-2 px-4 text-right text-2xl" />
            <span className="text-xl font-bold">MT</span>
          </div>
        </div>
        <div>
          <div className="mb-2 text-sm font-semibold">Validade</div>
          <div className="grid grid-cols-3 gap-2">
            {VALIDITY.map((x) => <button key={x.v} type="button" aria-pressed={validity === x.v} onClick={() => setValidity(x.v)} className={clsx('h-12 rounded-xl border-2 font-medium', validity === x.v ? 'border-brand-700 bg-brand-50/60 dark:bg-white/5' : 'border-base')}>{x.l}</button>)}
          </div>
        </div>
        <input aria-label="Quem compra (opcional)" placeholder="Quem compra (opcional)" value={buyer} onChange={(e) => setBuyer(e.target.value)} className="h-12 w-full rounded-xl border border-base bg-surface-2 px-4" />
        <p className="text-sm text-muted">Adiantamento sem IVA: o IVA é facturado na compra em que o vale for usado.</p>
        <button disabled={!n?.greaterThan(0)} className="h-14 w-full rounded-xl bg-brand-700 text-lg font-bold text-white disabled:opacity-40">Continuar para o pagamento</button>
      </form>
    </dialog>
  );
}
